class DomainProvider {
  // '~mathflat.com', '~mathflat.co.kr' 가 아닌 환경을 모두 local로 가정함(vercel, local 등)
  private _isLocalOrPreview = !/(^|\.)(scienceflat)\.(com|co\.kr)$/.test(window.location.hostname)

  private readonly _DEFAULT_DOMAIN = 'scienceflat.com'
  readonly TARGET_DOMAIN: string
  constructor() {
    this.TARGET_DOMAIN = this._setTargetDomain()
  }
  debugging({ isLiveEnv = false }: { isLiveEnv?: boolean } = {}) {
    if (!isLiveEnv) {
      if (typeof window !== 'undefined') {
        ;(window as any).setCustomDomain = this._setLocalTargetDomain
      }
      console.info('API target domain:', this.TARGET_DOMAIN)
    }
  }

  private _setTargetDomain() {
    try {
      if (this._isLocalOrPreview) {
        return localStorage.getItem('testDomain') || this._DEFAULT_DOMAIN
      }

      const hostname = window.location.hostname

      // hostname에서 teacher-dev.~, teacher.~, student.~, pdf.~, ... 제거
      const prefix = hostname.split('.')[0] + '.'
      return hostname.replace(prefix, '') || this._DEFAULT_DOMAIN
    } catch (e) {
      return this._DEFAULT_DOMAIN
    }
  }

  private _setLocalTargetDomain(domain: string) {
    localStorage.setItem('testDomain', domain)
  }
  replaceMathFlatDomain(url: string) {
    if (this._DEFAULT_DOMAIN !== this.TARGET_DOMAIN) {
      return url.replace(this._DEFAULT_DOMAIN, this.TARGET_DOMAIN)
    }
    return url
  }
  replaceAllMathFlatDomain(content: string) {
    if (this._DEFAULT_DOMAIN !== this.TARGET_DOMAIN) {
      return content.replaceAll(new RegExp(this._DEFAULT_DOMAIN, 'g'), this.TARGET_DOMAIN)
    }
    return content
  }
}

export const domainProvider = new DomainProvider()
